import { QuantityAdjuster } from 'components';
import React, { FC } from 'react';
import './split-card.scss';

type Props = {
    id: string | number
    leftSideQty: number,
    rightSideQty: number,
    leftSideHeaderText: string,
    rightSideHeaderText: string,
    minValue?: number,
    inputDelay?: number,
    onQuantityAdjusted?: (id: number | string | null, quantity: number) => void
    onLeftQuantityAdjusted?: (id: number | string | null, quantity: number) => void
    leftSideMaxValue?: number,
    rightSideMaxValue?: number
}

export const SplitCard: FC<Props> = ({ id, leftSideQty, rightSideQty, leftSideHeaderText, rightSideHeaderText, minValue, inputDelay = 0, onQuantityAdjusted, onLeftQuantityAdjusted, leftSideMaxValue, rightSideMaxValue }) => {

    const isDoubleAdjustable = !!onQuantityAdjusted && !!onLeftQuantityAdjusted;

    return (
        <div className={`split-card-details${isDoubleAdjustable ? ' double-adjustable' : ''}`}>
            <div className={'split-card-details-leftside'}>
                {onLeftQuantityAdjusted ?
                    <QuantityAdjuster
                        dataTestIdForButtons='split-button-left'
                        header={leftSideHeaderText}
                        quantity={leftSideQty}
                        minValue={minValue}
                        id={id}
                        iconSize={'2x'}
                        buttonSize={'40px'}
                        inputDelay={inputDelay}
                        maxValue={leftSideMaxValue}
                        onQuantityAdjusted={(id, quantity) => onLeftQuantityAdjusted(id, quantity)}
                    />
                    :
                    <>
                        <div className={'split-card-header'}>{leftSideHeaderText}</div>
                        <div className={'split-card-number'}>{leftSideQty}</div>
                    </>
                }
            </div>
            <div className={'split-card-details-rightside'}>
                {onQuantityAdjusted ?
                    <QuantityAdjuster
                        dataTestIdForButtons='split-button'
                        header={rightSideHeaderText}
                        quantity={rightSideQty}
                        minValue={minValue}
                        id={id}
                        iconSize={'2x'}
                        buttonSize={'40px'}
                        inputDelay={inputDelay}
                        maxValue={rightSideMaxValue}
                        onQuantityAdjusted={(id, quantity) => onQuantityAdjusted(id as number, quantity)}
                    />
                    :
                    <>
                        <div className={'split-card-header'}>{rightSideHeaderText}</div>
                        <div className={'split-card-number'}>{rightSideQty}</div>
                    </>
                }
            </div>
        </div>
    )
}